import type { CreditReportType } from '@zg-rentals/ts-capps-client';
import { DATA_UNAVAILABLE_TEXT } from '../../constants/credit-report-constants';
import { getTitleCase } from '@zg-rentals/formatters';

export const getCreditInquiries = (creditReport: CreditReportType) => {
  const { fullCreditProfile } = creditReport;

  if (fullCreditProfile?.Inquiry && Array.isArray(fullCreditProfile.Inquiry)) {
    const { Inquiry } = fullCreditProfile;

    return Inquiry.map((inquiry) => {
      const { Date: inquiryDate, KOB: businessType, SubscriberDisplayName: subscriber } = inquiry,
        date = inquiryDate || DATA_UNAVAILABLE_TEXT,
        type = businessType ? businessType.desc : '';

      return {
        date,
        name: getNameAndType(subscriber, type, ' - ') || 'name unavailable',
      };
    });
  }

  return [];
};

const getNameAndType = (name?: string, type?: string, separator = ' ') => {
  const nameTypeArray = [];

  if (name && typeof name === 'string') {
    nameTypeArray.push(getTitleCase(name));
  }

  if (type && typeof type === 'string') {
    nameTypeArray.push(type.toLowerCase());
  }

  if (nameTypeArray.length) {
    return nameTypeArray.join(separator);
  }
  return DATA_UNAVAILABLE_TEXT;
};
